/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown>, fee: NonNullable<unknown> }} Ticketsfeepreviewbuyer3Inputs */

const en_ticketsfeepreviewbuyer3 = /** @type {(inputs: Ticketsfeepreviewbuyer3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Buyers pay ${i?.total}, including a ${i?.fee} ticket fee.`)
};

const de_ticketsfeepreviewbuyer3 = /** @type {(inputs: Ticketsfeepreviewbuyer3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Käufer zahlen ${i?.total}, davon ${i?.fee} Ticketgebühr.`)
};

/**
* | output |
* | --- |
* | "Buyers pay {total}, including a {fee} ticket fee." |
*
* @param {Ticketsfeepreviewbuyer3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfeepreviewbuyer3 = /** @type {((inputs: Ticketsfeepreviewbuyer3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfeepreviewbuyer3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfeepreviewbuyer3(inputs)
	return de_ticketsfeepreviewbuyer3(inputs)
});
export { ticketsfeepreviewbuyer3 as "ticketsFeePreviewBuyer" }